/**
 * useUserFeed — ONE fetch of the signed-in user's rows for the whole explorer.
 *
 * My-data mode used to be half-real: the preview pane fetched the user's feed,
 * but the focus card, every connection card and the data zone each did their
 * own thing — the cards fell back to `mockFeed`, so the strip showed six mock
 * medicines beside a preview showing three real ones. Same widget, two truths.
 *
 * So the fetch lives here, once, and everything downstream renders the value
 * it returns: the tree, the focus card and the connection cards. An empty
 * result stays empty — the widget's own first-run state is the honest answer,
 * and mock data must never stand in for it.
 *
 * Returns `{ state, feed, instance, error }` where `state` is
 * `off` (mock mode) | `loading` | `not-adopted` | `ready` | `error`, and `feed`
 * is the `{ widget_id, instance_id, entries, settings, pending }` payload the
 * runtime and `buildRenderContext` both take.
 */
import useWidgetUserFeed from '../useWidgetUserFeed';

export default function useUserFeed(dataMode, widgetId, instanceId = null, reloadKey = 0) {
  return useWidgetUserFeed(dataMode === 'user', widgetId, instanceId, reloadKey);
}
